<template>
  <div style="position: relative">
    <div id="full-btn"
         @click="toggleFullScreen"
         :class="{'full-screen-btn': fullScreen}">
      <icon :name="fullScreen ? 'compress' : 'expand'"/>
    </div>
    <div :id="mapId"
         class="map"
         :class="{'full-screen': fullScreen}"
         v-show="map"></div>
    <div class="map map-box" v-show="!map">
      <div class="m-spinner"></div>
    </div>
  </div>
</template>

<script>
  import utils from '@/assets/utils/index'

  export default {
    components: {
    },
    props: {
      mapId: {
        type: String
      },
      options: { // init option
        type: Object,
        default () {
          return {// total usa map
            zoom: 4,
            center: {
              lat: 37.1,
              lng: -95.7
            },
            fullscreenControl: false
          }
        }
      },
      textSearchRequest: {
        type: Object,
        default () {
          return {
            query: ''
          }
        }
      }
    },
    computed: {
    },
    data () {
      return {
        map: null,
        fullScreen: false
      }
    },
    methods: {
      createMap () {
        utils.createMap(this.mapId, this.options)
        this.map = utils.maps[this.mapId]
        this.$emit('load')
      },
      toggleFullScreen () {
        this.fullScreen = !this.fullScreen
        this.$emit('full-screen', this.fullScreen)
      }
    },
    mounted () {
      if (this.$store.state.geo.isLoadGoogleMap) {
        this.createMap()
      } else {
        this.$store.commit('geo/saveKey', ['isLoadGoogleMap', true])

        let url = '//maps.google.com/maps/api/js?libraries=places,geometry,drawing'
        if (window.first.env === 'local' || window.first.env === 'dev') {
          url += '&client=gme-usadata&channel=salesleads360_staging'
        } else {
          url += '&client=gme-usadata&channel=salesleads360_prod'
        }
        utils.loadJs(url, this.createMap)
      }
    }
  }
</script>

<style scoped lang="scss">
  .map {
    width: 100%;
    height: 400px;
  }
  .map-box {
    padding-top: 100px;
    background-color: $color-primary-light;
    border: 1px solid $color-primary-light;
  }

  .m-spinner {
    background-color: $color-white;
  }

  #full-btn {
    position: absolute;
    background-color: $color-background;
    z-index: 201;
    right: 16px;
    top: 16px;
    width: 24px;
    height: 24px;
    text-align: center;
    line-height: 24px;
    cursor: pointer;
  }
  .full-screen {
    position: fixed !important;
    z-index: 200;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
  }
  .full-screen-btn {
    position: fixed !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/geo/MMap.vue